import React from 'react';

import { useAgentChatController } from '~/components/AgentChat/useAgentChatController';
import { FullScreenChatLayout } from '~/components/AiChat/containers/FullScreenChat/FullScreenChatLayout';
import { ChatControllerProvider } from '~/components/AiChat/controller/ChatControllerContext';
import type { ChatPresentation } from '~/components/AiChat/controller/types';

export interface AgentChatPanelProps {
  organizationId: number;
  agentKey: string;
  presentation: ChatPresentation;
}

/** A conversation with an in-app agent about an organization, in the claim full-screen chat's layout. */
export const AgentChatPanel: React.FC<AgentChatPanelProps> = ({ organizationId, agentKey, presentation }) => {
  const controller = useAgentChatController({ organizationId, agentKey, presentation });

  return (
    // Virtuoso lays the transcript out in the height its parent gives it, and nothing above bounds a page's.
    <div className="h-[70vh] min-h-[480px] w-full overflow-hidden">
      <ChatControllerProvider controller={controller}>
        <FullScreenChatLayout />
      </ChatControllerProvider>
    </div>
  );
};
